<template>
  <footer class="site-footer">
    <div class="footer-body">
      <div class="footer-container">

        <!-- 品牌列 - logo和文字并排 -->
        <div class="footer-brand">
          <div class="footer-brand-top">
            <div class="footer-logo-wrap">
              <img src="@/assets/img/logo_black.png" alt="企文达" class="footer-logo" />
            </div>
            <p class="footer-tagline">企筑文化，万事可达。专注企业文化一站式全案服务，让老板经营企业更简单。</p>
          </div>
          <div class="footer-socials">
            <a href="#" class="footer-social" title="微信"><i class="fab fa-weixin"></i></a>
            <a href="#" class="footer-social" title="微博"><i class="fab fa-weibo"></i></a>
            <a href="#" class="footer-social" title="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
          </div>
        </div>

        <!-- 快速导航 -->
        <div class="footer-col">
          <h4 class="footer-col-hd">快速导航</h4>
          <ul class="footer-nav">
            <li><router-link to="/home">首页</router-link></li>
            <li><router-link to="/companyintroduction">关于我们</router-link></li>
            <li><router-link to="/software">服务类目</router-link></li>
            <li><router-link to="/newsinformation">发展历程</router-link></li>
            <li><router-link to="/service">文达智堂</router-link></li>
            <li><router-link to="/jobchance">人才培育</router-link></li>
            <li><router-link to="/contactus">联系我们</router-link></li>
          </ul>
        </div>

        <!-- 联系信息 -->
        <div class="footer-col">
          <h4 class="footer-col-hd">联系我们</h4>
          <ul class="footer-contact">
            <li>
              <span class="fc-icon"><i class="fas fa-phone-alt"></i></span>
              <span>15700062225</span>
            </li>
            <li>
              <span class="fc-icon"><i class="fas fa-envelope"></i></span>
              <span>15700062225@163.com</span>
            </li>
            <li>
              <span class="fc-icon"><i class="fas fa-clock"></i></span>
              <span>7×24小时为您服务</span>
            </li>
            <li>
              <span class="fc-icon"><i class="fas fa-map-marker-alt"></i></span>
              <span>杭州市上城区凯旋路12号</span>
            </li>
          </ul>
        </div>

        <!-- 服务时间 -->
        <div class="footer-col">
          <h4 class="footer-col-hd">服务时间</h4>
          <div class="footer-hours">
            <div class="fh-row">
              <span class="fh-day">工作日</span>
              <span class="fh-time">09:00 — 18:00</span>
            </div>
            <div class="fh-row">
              <span class="fh-day">周末</span>
              <span class="fh-time">10:00 — 17:00</span>
            </div>
            <div class="fh-row">
              <span class="fh-day">紧急支持</span>
              <span class="fh-time">7×24小时</span>
            </div>
          </div>
          <router-link to="/contactus" class="footer-cta">
            立即联系 <i class="fas fa-arrow-right"></i>
          </router-link>
        </div>

      </div>
    </div>

    <!-- 底部版权栏 -->
    <div class="footer-bottom">
      <div class="footer-container footer-bottom-inner">
        <p>Copyright &copy; 2013 – {{ year }} 杭州企信通企业服务有限公司 版权所有 · <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener" class="icp-link">浙ICP备2024059028号-4</a></p>
        <div class="footer-bottom-links">
          <router-link to="/privacy">隐私政策</router-link>
          <span class="sep">·</span>
          <router-link to="/terms">服务条款</router-link>
          <span class="sep">·</span>
          <router-link to="/admin">管理后台</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    year() { return new Date().getFullYear() }
  }
}
</script>

<style scoped>
.site-footer {
  background: #0f1628;
  color: #8a9bb8;
  font-size: 14px;
}

/* 主体 */
.footer-body {
  padding: 72px 0 56px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 2.2fr 1fr 1.2fr 1.2fr;
  gap: 52px;
  align-items: start;
}

/* 品牌列 */
.footer-brand-top {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
}
.footer-logo-wrap {
  flex-shrink: 0;
  filter: brightness(0) invert(1);
  opacity: 0.9;
}
.footer-logo {
  height: 80px;
  width: auto;
  display: block;
}
.footer-tagline {
  font-size: 14px;
  color: #8a9bb8;
  line-height: 1.85;
  margin: 0;
}
.footer-socials {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}
.footer-social {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.08);
  color: #6a7e9a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  text-decoration: none;
  transition: background 0.2s, color 0.2s, transform 0.2s, border-color 0.2s;
}
.footer-social:hover {
  background: #007bff;
  border-color: #007bff;
  color: #fff;
  transform: translateY(-2px);
}

/* 列标题 */
.footer-col-hd {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 22px;
  padding-bottom: 12px;
  border-bottom: 2px solid #007bff;
  display: inline-block;
  letter-spacing: 0.5px;
}

/* 导航链接 */
.footer-nav {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 11px;
}
.footer-nav a {
  color: #5a6e8a;
  text-decoration: none;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 7px;
  transition: color 0.2s, padding-left 0.2s;
}
.footer-nav a::before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #007bff;
  opacity: 0.5;
  flex-shrink: 0;
  transition: opacity 0.2s;
}
.footer-nav a:hover {
  color: #fff;
  padding-left: 4px;
}
.footer-nav a:hover::before {
  opacity: 1;
}

/* 联系信息 */
.footer-contact {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 13px;
}
.footer-contact li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: #5a6e8a;
  line-height: 1.5;
}
.fc-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: rgba(0,123,255,0.1);
  color: #4da3ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
  margin-top: 1px;
}

/* 服务时间 */
.footer-hours {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 24px;
}
.fh-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  font-size: 13px;
}
.fh-row:last-child { border-bottom: none; }
.fh-day { color: #5a6e8a; }
.fh-time { color: #c8d4e8; font-weight: 600; }

/* 联系按钮 */
.footer-cta {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #007bff, #0056d2);
  color: #fff;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(0,123,255,0.3);
  transition: transform 0.2s, box-shadow 0.2s;
}
.footer-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,123,255,0.4);
  color: #fff;
}

/* 底部版权 */
.footer-bottom {
  padding: 18px 0;
  background: #0a1020;
}
.footer-bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}
.footer-bottom p {
  font-size: 12px;
  color: #3a4e68;
  margin: 0;
}
.footer-bottom-links {
  display: flex;
  align-items: center;
  gap: 10px;
}
.footer-bottom-links a {
  font-size: 12px;
  color: #3a4e68;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-bottom-links a:hover { color: #8a9bb8; }
.icp-link { color: #3a4e68; text-decoration: none; transition: color 0.2s; }
.icp-link:hover { color: #8a9bb8; }
.sep { color: #2a3a52; font-size: 12px; }

/* 响应式 */
@media (max-width: 1024px) {
  .footer-container {
    grid-template-columns: 1fr 1fr;
    gap: 36px;
  }
  .footer-brand { grid-column: 1 / -1; }
  .footer-tagline { max-width: 100%; }
}
@media (max-width: 576px) {
  .footer-container { grid-template-columns: 1fr; gap: 28px; }
  .footer-body { padding: 48px 0 36px; }
  .footer-bottom-inner { flex-direction: column; text-align: center; }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue